export default {
  'previous-editions': [
    {
      id: 0,
      label: {
        it: 'Bilancio Sociale 2021',
        en: '2021 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2021_ITA.pdf',
          en: '/pdf/FA_BS_2021_ENG.pdf'
        },
        size: '2.4MB'
      }
    },
    {
      id: 1,
      label: {
        it: 'Bilancio Sociale 2020',
        en: '2020 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2020_ITA.pdf',
          en: '/pdf/FA_BS_2020_ENG.pdf'
        },
        size: '2.5MB'
      }
    },
    {
      id: 2,
      label: {
        it: 'Bilancio Sociale 2019',
        en: '2019 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2019_IT.pdf',
          en: '/pdf/FA_BS_2019_ENG.pdf'
        },
        size: '5.3MB'
      }
    },
    {
      id: 3,
      label: {
        it: 'Bilancio Sociale 2018',
        en: '2018 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2018.pdf',
          en: '/pdf/FA_BS_2018.pdf'
        },
        size: '2MB'
      }
    },
    {
      id: 4,
      label: {
        it: 'Bilancio Sociale 2017',
        en: '2017 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2017.pdf',
          en: '/pdf/FA_BS_2017.pdf'
        },
        size: '2MB'
      }
    },
    {
      id: 5,
      label: {
        it: 'Bilancio Sociale 2016',
        en: '2016 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2016.pdf',
          en: '/pdf/FA_BS_2016.pdf'
        },
        size: '1MB'
      }
    },
    {
      id: 6,
      label: {
        it: 'Bilancio Sociale 2015',
        en: '2015 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2015.pdf',
          en: '/pdf/FA_BS_2015.pdf'
        },
        size: '1MB'
      }
    },
    {
      id: 7,
      label: {
        it: 'Bilancio Sociale 2014',
        en: '2014 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2014.pdf',
          en: '/pdf/FA_BS_2014.pdf'
        },
        size: '1MB'
      }
    },
    {
      id: 8,
      label: {
        it: 'Bilancio Sociale 2013',
        en: '2013 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2013.pdf',
          en: '/pdf/FA_BS_2013.pdf'
        },
        size: '1MB'
      }
    },
    {
      id: 9,
      label: {
        it: 'Bilancio Sociale 2012',
        en: '2012 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2012.pdf',
          en: '/pdf/FA_BS_2012.pdf'
        },
        size: '1.9MB'
      }
    },
    {
      id: 10,
      label: {
        it: 'Bilancio Sociale 2011',
        en: '2011 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2011.pdf',
          en: '/pdf/FA_BS_2011.pdf'
        },
        size: '2.1MB'
      }
    },
    {
      id: 11,
      label: {
        it: 'Bilancio Sociale 2010',
        en: '2010 Social Report'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_BS_2010.pdf',
          en: '/pdf/FA_BS_2010.pdf'
        },
        size: '2.5MB'
      }
    }
  ],
  'added-value': [
    {
      id: 12,
      label: {
        it: 'FA VALORE AGGIUNTO 2021',
        en: 'FA 2021 VALUE ADDED'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_2021_VA_ITA.pdf',
          en: '/pdf/FA_2021_VA_ENG.pdf'
        },
        size: '31KB'
      }
    }
  ],
  'behind-the-number': [
    {
      id: 13,
      label: {
        it: 'FA_INIZIATIVE PER AREA',
        en: 'FA_INITIATIVES BY AREA'
      },
      file: {
        format: 'PDF',
        path: {
          it: '/pdf/FA_2021_AR_ITA.pdf',
          en: '/pdf/FA_2021_AR_ENG.pdf'
        },
        size: '25KB'
      }
    }
  ]
};
